
























import Popup from '@/views/organisms/Popup.vue'
import store from '@/store'
import BlueButton from '@/views/atoms/BlueButton.vue'
import TextBox from '@/views/atoms/TextBox.vue'
import PopupComfirmEdit from '@/views/template/PopupComfirmEdit.vue'
import ErrorLabel from '@/views/atoms/ErrorLabel.vue'

export default
  name: 'PopupGasMeterEdit'
  components: {
    Popup
    BlueButton
    TextBox
    PopupComfirmEdit
    ErrorLabel
  }

  props:
    gasMeter:
      type: String
      default: ''
    dateTime:
      type: String
      default: ''
    admin:
      type: Boolean
      default: true

  data: () ->
    inputGasMeter: ''
    inputDateTime: ''
    isShowPopup: {}

  created: () ->
    store.dispatch('setErrors', [])
    @inputGasMeter = @gasMeter
    @inputDateTime = @dateTime

  methods: {
    close_popup: (e) ->
      @$emit('close_popup')
    save: () ->
      # @inputDateTimeで変更した日時を取得できる
      # @inputGasMeterで変更したガスメーターの値を取得できる
      val = 
        value: @inputGasMeter
        created: @inputDateTime
      @closePopup('edit')
      @$emit('save', val)
    change: (e) -> 
      @inputGasMeter = e.val
    showPopup: (property) ->
      @$set(@isShowPopup, property, true)
    closePopup: (property) ->
      @$set(@isShowPopup, property, false)
  }
